import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'inline' | 'large';
}
export function CountdownTimer({
  variant = 'inline'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  if (variant === 'inline') {
    return <span className="font-bold text-sci-orange" aria-live="polite" data-id="element-40">
        {hours}:{minutes}:{seconds}
      </span>;
  }
  return <div className="flex gap-2 justify-center items-center text-sci-orange font-bold" aria-live="polite" data-id="element-41">
      <div className="text-3xl md:text-5xl" data-id="element-42">{hours}</div>
      <div className="text-2xl md:text-4xl" data-id="element-43">HS :</div>
      <div className="text-3xl md:text-5xl" data-id="element-44">{minutes}</div>
      <div className="text-2xl md:text-4xl" data-id="element-45">MIN :</div>
      <div className="text-3xl md:text-5xl" data-id="element-46">{seconds}</div>
      <div className="text-2xl md:text-4xl" data-id="element-47">SEG</div>
    </div>;
}